<template>
    <div class="no-profile">
        <div class="header">
            <h2>{{ $t('You don\'t have a profile for this segment') }}</h2>
            <p>{{ $t('Submit a membership request') }}</p>
        </div>
        <v-form v-model="valid"
                :class="'request-form' + (loading
                    ? ' disabled'
                    : ''
                )"
                v-on:submit.prevent="submit"
        >
            <v-text-field
                prepend-icon="fa-globe"
                v-model="form.website"
                :label="$t('Website')"
                :rules="[rules.required, rules.url]"
            ></v-text-field>
            <v-text-field
                prepend-icon="fab fa-facebook"
                v-model="form.facebook"
                label="Facebook"
                :rules="[rules.facebook]"
            ></v-text-field>
            <v-textarea
                prepend-icon="fa-comment-alt"
                v-model="form.message"
                :label="$t('Message')"
                counter
                rows="6"
                maxlength="600"
                :rules="[rules.required]"
            ></v-textarea>
            <v-alert
                v-if="error"
                :value="true"
                type="error"
                class="notranslate"
            >{{error}}</v-alert>
            <v-btn type="submit"
                   style="color: #fff;"
                   :loading="loading"
                   :disabled="loading || !valid"
                   color="accent"
            >{{ $t('Submit') }}</v-btn>
        </v-form>
    </div>
</template>

<script>
import { UPDATE_SEGMENTS } from '../store/types'
import { membershipRequest } from '../utils/api'
export default {
  name: 'EmptyProfile',
  props: {
    segment: String
  },
  data: () => ({
    rules: {
      required: value => !!value || 'Campo obrigatório.',
      url: value => {
        const pattern = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)/g
        return pattern.test(value) || 'URL inválido.'
      },
      facebook: value => {
        const pattern = /^(https?:\/\/)?((w{3}\.)?)facebook.com\/.*/i
        return pattern.test(value) || 'Preencha um URL válido do facebook.'
      }
    },
    form: {
      website: '',
      facebook: '',
      message: ''
    },
    valid: false,
    loading: false,
    error: false
  }),
  methods: {
    submit: function () {
      this.loading = true
      this.error = false
      membershipRequest({
        name: this.$store.state.user.name,
        phone_number: this.$store.state.user.phone_number,
        email: this.$store.state.user.email,
        website: this.form.website,
        facebook: this.form.facebook,
        country: this.$store.state.user.address.country,
        city: this.$store.state.user.address.city,
        segment: this.segment,
        message: this.form.message
      }).then(async results => {
        if (results.result !== 'error') {
          await this.$store.dispatch(UPDATE_SEGMENTS)
          this.loading = false
        } else {
          this.error = this.$t('There is a problem with your form submission')
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss">
.no-profile {
    padding: 48px 24px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .header {
        max-width: 640px;
        text-align: center;
    }
    .request-form {
        width: 100%;
        max-width: 760px;
        margin: 24px;
        &.disabled {
            pointer-events: none;
            opacity: 0.6;
        }
        .v-input {
            margin: 12px 0;
        }
        button {
            display: block;
            margin: 24px auto 0;
        }
    }
}
</style>

<i18n>
    {
        "en":{
            "You don't have a profile for this segment": "You don't have a profile for this segment",
            "Submit a membership request": "If you also wish to have a profile in this segment, please submit a membership request below:",
            "Message": "Message",
            "There is a problem with your form submission": "There is a problem with your form submission, try again later. If the problem persists, contact us."
        },
        "pt":{
            "You don't have a profile for this segment": "Você não tem um perfil para esse segmento",
            "Submit a membership request": "Caso você deseje também ter um perfil nesse segmento, envie uma solicitação de adesão abaixo:",
            "Message": "Messagem",
            "Submit": "Enviar",
            "There is a problem with your form submission": "Houve um problema ao enviar a solicitação, tente novamente mais tarde. Caso o problema persistir, entre em contato."
        }
    }
</i18n>
